module.exports = __webpack_public_path__ + "media/images/athletes/1917-a74f1aa3a0bae54456e21508e441d5c9.png";